import { activityIcicleTaxonomy } from './activity';
import { geographyIcicleTaxonomy } from './geography';
import { industryIcicleTaxonomy } from './industry';
import { roleIcicleTaxonomy } from './role';
import { skillIcicleTaxonomy } from './skill';
import type { IcicleTaxonomy, IcicleTaxonomySegment } from './types';

export const ICICLE_TAXONOMIES: Record<IcicleTaxonomySegment, IcicleTaxonomy> =
  {
    role: roleIcicleTaxonomy,
    geography: geographyIcicleTaxonomy,
    rics: industryIcicleTaxonomy,
    skills: skillIcicleTaxonomy,
    activities: activityIcicleTaxonomy,
  };
